import React, { useEffect, useRef, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import "@adyen/adyen-web/styles/adyen.css";
import { REDIRECT_RESULT_PARAMETER } from "./paymentPage.constants";
import { NO_ORDER_SUMMARY } from "./paymentPageCheckout.configuration";
import { PAGE_VIEW } from "./paymentPage.views";
import { disposeDropin, loadPaymentPage, openPaymentFormAgain, startPageStatePolling } from "./paymentPage.flow";
import { createPaymentPageDropinCallbacks } from "./paymentPageDropin.callbacks";
import { createPaymentPageScope } from "./paymentPageOperation.scope";
import PaymentPageLayout from "./PaymentPageLayout";

const NO_REDIRECT_RESULT = Object.freeze({ isPresent: false });

function readRedirectResult(redirectResult) {
    if (redirectResult === null) {
        return NO_REDIRECT_RESULT;
    }
    return Object.freeze({ isPresent: true, value: redirectResult });
}


function PaymentPage() {
    const { referenceId } = useParams();
    const [searchParameters] = useSearchParams();
    const redirectResult = searchParameters.get(REDIRECT_RESULT_PARAMETER);
    const [pageView, setPageView] = useState(PAGE_VIEW.LOADING);
    const [orderSummary, setOrderSummary] = useState(NO_ORDER_SUMMARY);
    const dropinContainer = useRef();
    const dropinInstance = useRef(null);
    const pageContextReference = useRef();


    function handleTryAgain() {
        openPaymentFormAgain(pageContextReference.current);
    }


    useEffect(
        function loadPageOnOpen() {
            const context = createPaymentPageScope({
                paymentLinkId: referenceId,
                redirectResult: readRedirectResult(redirectResult),
                updateView: setPageView,
                updateOrderSummary: setOrderSummary,
                dropinContainer,
                dropinInstance,
            });
            context.dropinCallbacks = createPaymentPageDropinCallbacks(context);
            pageContextReference.current = context;
            setPageView(PAGE_VIEW.LOADING);
            setOrderSummary(NO_ORDER_SUMMARY);
            loadPaymentPage(context);
            return () => { context.dispose(); disposeDropin(context); };
        },
        [referenceId, redirectResult]
    );

    useEffect(
        function startPollingWhileWaiting() {
            return startPageStatePolling(pageContextReference.current, pageView);
        },
        [pageView, referenceId, redirectResult]
    );

    return (
        <PaymentPageLayout
            pageView={pageView}
            orderSummary={orderSummary}
            dropinContainer={dropinContainer}
            onTryAgain={handleTryAgain}
        />
    );
}

export default PaymentPage;
